module.exports = __webpack_public_path__ + "media/images/products/shop/2-576c0db46e908f34736f606baf151cd9.jpg";